/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from 'react';
import { func, number, shape } from 'prop-types';

import noop from 'lodash/noop';
import isEqual from 'lodash/isEqual';

import { EVENTS } from './constants';
import helpers from './helpers';

const { addListener, getMarker } = helpers;

const Marker = ({ content, lat, lng, map, onClick, onMouseOver, onMouseOut }) => {
  const [marker, setMarker] = useState(null);

  useEffect(() => {
    const markerInstance = getMarker({ content, map, position: { lat, lng } });

    if (markerInstance) {
      setMarker(markerInstance);

      return () => markerInstance.setMap(null);
    }

    return noop;
  }, [map, lat, lng]);

  useEffect(() => addListener(marker, EVENTS.CLICK, onClick), [marker, onClick]);

  useEffect(() => addListener(marker, EVENTS.MOUSE_OVER, onMouseOver), [marker, onMouseOver]);

  useEffect(() => addListener(marker, EVENTS.MOUSE_OUT, onMouseOut), [marker, onMouseOut]);

  return null;
};

Marker.propTypes = {
  content: shape(),
  lat: number.isRequired,
  lng: number.isRequired,
  map: shape().isRequired,
  onClick: func,
  onMouseOut: func,
  onMouseOver: func,
};

const arePropsEqual = ({ icon: prevIcon, ...prevProps }, { icon: nextIcon, ...nextProps }) =>
  isEqual(prevIcon, nextIcon) || isEqual(prevProps, nextProps);

export default memo(Marker, arePropsEqual);
